/* eslint-disable consistent-return */
import http from "../../auth/http-common";

import { URL } from "../../constants/api-constants";
import { OrgMember } from "../../types/organizations";

export type Organization = {
  id: string;
  name: string;
  is_active: boolean;
  isTecheat: boolean;
  created_at: Date;
  updated_at: Date;
};

export type OrganizationWithRelation = Organization & {
  members: OrgMember[];
};

const getCount = async (): Promise<number | undefined> => {
  try {
    const response = await http.get(URL.ORGANIZATIONS_COUNT);
    return response.data.count;
  } catch (error) {
    console.error(error);
  }
};

const getMany = async (): Promise<Organization[] | undefined> => {
  try {
    const response = await http.get(URL.ORGANIZATIONS_LIST);
    return response.data.items;
  } catch (error) {
    console.error(error);
  }
};

export const organizationsProvider = {
  getCount,
  getMany,
};
